var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 text-center"},[_c('h1',{domProps:{"innerHTML":_vm._s(_vm.title)}}),_c('h2',{staticClass:"primary--text my-3"},[_vm._v("Please check back soon!")])])}
var staticRenderFns = []

export { render, staticRenderFns }